import { render, staticRenderFns } from "./fitting-info.vue?vue&type=template&id=2aaa9d78&scoped=true&"
import script from "./fitting-info.vue?vue&type=script&lang=js&"
export * from "./fitting-info.vue?vue&type=script&lang=js&"
import style0 from "./fitting-info.vue?vue&type=style&index=0&id=2aaa9d78&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa9d78",
  null
  
)

export default component.exports